const locks = new Set<string>()

function apply() {
	window.onbeforeunload = isNavLocked() ? () => 'never' : null
}

export function addNavLock(id: string) {
	locks.add(id)
	apply()
}

export function removeNavLock(id: string) {
	locks.delete(id)
	apply()
}

export function setNavLock(id: string, locked: boolean) {
	if (locked) addNavLock(id)
	else removeNavLock(id)
}

export function isNavLocked() {
	return locks.size > 0
}
